import React from "react"
import styled from "styled-components"
import Typography from "@material-ui/core/Typography"

const BulletList = props => {
  const { list_column } = props
  return (
    <Container>
      {!!list_column &&
        list_column.map(({ list }, index) => {
          return (
            <List key={index}>
              {!!list &&
                list.map(({ item }, index) => {
                  return (
                    <Item key={index}>
                      <Typography variant="body1">{item}</Typography>
                    </Item>
                  )
                })}
            </List>
          )
        })}
    </Container>
  )
}

export default BulletList

const List = styled.ul`
  width: 100%;
  list-style-type: disc;
  padding-left: 22px;
  &:last-of-type {
    margin-left: 16px;
  }
`
const Item = styled.li`
  padding-bottom: 22px;
`

const Container = styled.div`
  display: flex;
  padding-bottom: 50px;
`
